import universityData from "./UniversityData";
import stateDistrictData from "./StateDistrictData";

export default {
    
/////////////////////////////////////////// Rank Drop pDown Data ////////////////////////////////////////////////////

    rank: [["1", "Mr."], ["2", "Ms."]],
    
    getRanks() { return this.rank; } ,

/////////////////////////////////////////// Merital Status Drop pDown Data //////////////////////////////////////////

    mStatus: [["1", "Single"], ["2", "Married"]],
    mStatusFemale: [["1", "Single"], ["2", "Married"],["3", "Widow/Divorced Women"]],
    
    getMStatus(gender) {
        if (gender == 'M') {
            return this.mStatus;    
        }
        else {
            return this.mStatusFemale;   
        }
    },

///////////////////////////////////////////// ExService Drop pDown Data ///////////////////////////////////////////////

    exServiceType: [["-1", "-"], ["1", "Army"], ["2", "Navy"], ["3", "Air Force"]],
    
    getExServiceType() { return this.exServiceType; },

  ///////////////////////////////////////////////// State //////////////////////////////////////////////////////////////////////////// 
    
    getState(nationid) {
        return stateDistrictData.state.filter(f => { return f[2] == nationid });
    },

//////////////////////////////////////////////////Distrinct ////////////////////////////////////////////////////////////    
    getDistrict() {
        return stateDistrictData.district;
    },
    
////////////////////////////////////////// /// Religion Drop pDown Data //////////////////////////////////////////

    religion: [["1", "HINDU"], ["2", "MUSLIM"], ["3", "SIKH"], ["4", "CHRISTIAN"], ["5", "PARSI"], ["6", "BUDDHIST"], ["7", "JAIN"], ["8", "OTHERS"]],
    
    getReligion() {
        return this.religion;
    },

////////////////////////////////////////// /// Sports Level ////////////////////////////////////////////////////////////////////////////////////

    sportsLevel: [["1", "-"], ["2", "District I/II Pos"], ["3", "State"], ["4", "National"], ["5", "Inter-National"]],
    
    getSportsLevel() {
        return this.sportsLevel;
    },

///////////////////////////////////////////// Sports Level ////////////////////////////////////////////////////////////////////////////////////

    sportsMedal: [["1", "Gold", "1"], ["2", "Silver", "2"], ["3", "Bronze", "3"], ["4", "Participated", "4"]],
    
    getSportsMedal() {
        return this.sportsMedal;
    },

////////////////////////////////////////// // Sports ////////////////////////////////////////////////////////////////////////////////////

    sport: [["1", "Archery", "1"], ["2", "Athletics (incl Track & Field Event)", "2"], ["3", "Atya-Patya", "3"], ["4", "Badminton", "4"], ["5", "Ball-Badminton", "5"], ["6", "Basketball", "6"], ["7", "Billiards & Snooker", "7"], ["8", "Boxing", "8"], ["9", "Bridge", "9"], ["10", "Carrom", "10"], ["11", "Chess", "11"], ["12", "Cricket", "12"], ["13", "Cycling", "13"], ["14", "Equestrian Sports", "14"], ["15", "Football", "15"], ["16", "Golf", "16"], ["17", "Gymnastics (incl Body Building)", "17"], ["18", "Handball", "18"], ["19", "Hockey", "19"], ["21", "Ice-Hockey", "20"], ["22", "Ice-Skating", "21"], ["20", "Ice-Skiing", "22"], ["23", "Judo", "23"], ["24", "Kabaddi", "24"], ["25", "Karate-Do", "25"], ["26", "Kayaking & Canoeing", "26"], ["27", "Kho-Kho", "27"], ["28", "Polo", "28"], ["29", "Powerlifting", "29"], ["30", "Rifle Shooting", "30"], ["31", "Rollar Skating", "31"], ["32", "Rowing", "32"], ["33", "Soft Ball", "33"], ["34", "Squash", "34"], ["35", "Swimming", "35"], ["36", "Table Tennis", "36"], ["37", "Taekwondo", "37"], ["39", "Tennis", "38"], ["38", "Tennis-Koit", "39"], ["40", "Vollyball", "40"], ["41", "Weightlifting", "41"], ["42", "Wrestling", "42"], ["43", "Yatching", "43"]],
    
    getSport() {
        return this.sport;
    },

////////////////////////////////////////// // Qualification ////////////////////////////////////////////////////////////////////////////////////

    qualification: [["0", "Others", "0", "-1", "-1", "-1"], ["1", "10th", "1", "1", "1", "2"], ["2", "12th", "2", "1", "2", "2"], ["3", "Graduation(From Recognised University)", "3", "1", "3", "1"], ["4", "Graduation(B Sc)", "3", "1", "3", "1"], ["5", "Graduation(B Sc Agriculture)", "3", "1", "3", "1"], ["6", "Graduation(B A)", "3", "1", "3", "1"], ["7", "ITI certificate in respective Trade", "2", "1", "2", "1"], ["8", "Diploma Engg.", "2", "1", "2", "1"], ["9", "Diploma in Material Management", "2", "1", "2", "1"], ["11", "Diploma / Certificate of respective Trade", "2", "1", "2", "1"]],
    
    getQualification() {
        return this.qualification;
    },

    qualCertificate: [["0", "Others", "0", "-1", "-1", "-1"], ["16", "Experience ( Respective Trade )", "7", "2", "9", "-1"], ["17", "Driving Experience for Heavy Vehicle", "7", "2", "9", "-1"], ["18", "Proficiency in handling PBX Board", "7", "2", "9", "-1"], ["19", "Typing speed 35 wpm in English", "7", "2", "9", "-1"], ["20", "Dictation:10mts@80w.p.m. and Transcription: 50 mts(Eng) on Computer", "7", "2", "9", "-1"], ["22", "Typing speed 30 wpm in Hindi", "7", "2", "9", "-1"], ["24", "Dictation:10mts@80w.p.m. and Transcription: 65 mts(Hindi) on Computer", "7", "2", "9", "-1"]],
    
    getQualCertificate() {
        return this.qualCertificate;
    },

//////////////////////////////////////////// Univercity ////////////////////////////////////////////////////////////////////////////////////

    getUniversity() {
        return universityData.universities;
    },

//////////////////////////////////////////// Year ////////////////////////////////////////////////////////////////////////////////////
    getYear(yearofbirth) {
        let year = [];
        let fromYear = parseInt(yearofbirth);
        let toYear = new Date().getFullYear();
        for (let y = fromYear; y <= toYear; y++) {
            year.push({ 0: y.toString() });
        }
        return year;
    },
/////////////////////////////////////////// Experience Year ////////////////////////////////////////////////////////////////////////////////////
    getExpYear(yearofbirth) {
        let year = [];
        let fromYear = parseInt(yearofbirth);
        let toYear = new Date().getFullYear();
        let counter = toYear - fromYear;
        for (let y = 0; y <= counter; y++) {
            year.push({ 0: y.toString() });
        }
        return year;
    },

////////////////////////////////////////// Experience Month ////////////////////////////////////////////////////////////////////////////////////
    getExpMonth() {
        let month = [];
        let counter = 11;
        for (let y = 0; y <= counter; y++) {
            month.push({ 0: y.toString() });
        }
        return month;
    },

////////////////////////////////////////// ICard  ////////////////////////////////////////////////////////////////////////////////////
    
    //iCard :[["1", "Aadhaar Card", "Aadhaar Card", "True"], ["2", "PAN Card", "PAN Card", "True"], ["3", "Driving License", "DL", "True"], ["4", "Voter ID", "Voter ID", "True"], ["5", "Passport", "Passport", "True"]],
    iCard :[["2", "PAN Card", "PAN Card", "True"], ["3", "Driving License", "DL", "True"], ["4", "Voter ID", "Voter ID", "True"], ["5", "Passport", "Passport", "True"]],
   
    getICard() {
        return this.iCard;
    },

////////////////////////////////////////// Nationality  ///////////////////////////////////////////////////////////////////////////////
    
    nationality :[["11","Nepal","Nepal"],["12","Bhutan","Bhutan"],["13","Tibetan","Tibetan"]],
   
    getNationality() {
        return this.nationality;
    }

    
    
}


// WEBPACK FOOTER //
// ./src/components/servicesjs/MasterObject.js